module.exports = __webpack_public_path__ + "img/pause.978ca06a.svg";